import { FC } from 'react';

import { RequiredRule } from 'devextreme-react/cjs/form';
import { DropDownOptions } from 'devextreme-react/cjs/select-box';

import { AppFieldBox } from 'components/appComponents';
import { DateBox, SelectBox, TextArea, Validator } from 'devextreme-react';
import DataSource from 'devextreme/data/data_source';
import { OfflineRequestsForm, OfflineRequestsItem } from 'pages/OfflineRequests/OfflineRequests.entity';

import { MethodOfReceptionItem } from 'bus/methodOfReception/types';

type Props = {
  possibleRequests: DataSource;
  storeEmployee: DataSource;
  storeTransport: DataSource;
  methodOfReceptionList: MethodOfReceptionItem[] | undefined;
  form: OfflineRequestsForm;
  detail?: OfflineRequestsItem;
  onChange: (name: keyof OfflineRequestsForm, value: OfflineRequestsForm[keyof OfflineRequestsForm]) => void;
};

export const EditOfflineRequestsForm: FC<Props> = ({
  possibleRequests,
  detail,
  storeTransport,
  storeEmployee,
  methodOfReceptionList,
  form,
  onChange,
}) => {
  return (
    <div>
      <AppFieldBox label="Дата" labelTop>
        <DateBox
          stylingMode="underlined"
          type="datetime"
          useMaskBehavior
          //dateSerializationFormat="yyyy-MM-dd:"
          value={detail?.completedDate || ''}
          readOnly
        ></DateBox>
      </AppFieldBox>

      <AppFieldBox label="Заявка" labelTop>
        <SelectBox
          stylingMode="underlined"
          dataSource={possibleRequests}
          displayExpr="id"
          valueExpr="id"
          value={form.requestId}
          searchEnabled
          onItemClick={(e) => {
            onChange('requestId', e.itemData.id);
          }}
        >
          <DropDownOptions title="Выберите заявку" closeOnOutsideClick={true} showTitle={false} />
          {/*          <Validator>
            <RequiredRule message="Выберите заявку" />
          </Validator> */}
        </SelectBox>
      </AppFieldBox>

      <AppFieldBox label="Метод приёма" labelTop>
        <SelectBox
          stylingMode="underlined"
          placeholder="Выберите метод приёма"
          mode="text"
          value={form.methodOfReceptionId}
          onValueChange={(e) => {
            onChange('methodOfReceptionId', e);
          }}
          searchMode="contains"
          searchExpr="displayName"
          searchEnabled
          displayExpr="displayName"
          valueExpr="id"
          //dataSource={storeTransport.data.map((i: any) => i.id > 0)}
          dataSource={methodOfReceptionList}
        >
          {/*         <Validator>
            <RequiredRule message="Выберите метод приёма" />
          </Validator> */}
        </SelectBox>
      </AppFieldBox>

      <AppFieldBox label="Транспорт" labelTop>
        <SelectBox
          stylingMode="underlined"
          dataSource={storeTransport}
          displayExpr="fullName"
          valueExpr="id"
          value={form.transportId}
          searchEnabled
          onItemClick={(e) => {
            onChange('transportId', e.itemData.id);
          }}
        >
          <DropDownOptions title="Выберите контрагента" closeOnOutsideClick={true} showTitle={false} />
          <Validator>
            <RequiredRule message="Выберите контрагента" />
          </Validator>
        </SelectBox>
      </AppFieldBox>

      <AppFieldBox label="Водитель" labelTop>
        <SelectBox
          stylingMode="underlined"
          placeholder="Выберите водителя"
          mode="text"
          value={form.driverId}
          onValueChange={(e) => {
            onChange('driverId', e);
          }}
          searchMode="contains"
          searchExpr="fullName"
          searchEnabled
          displayExpr="fullName"
          valueExpr="id"
          dataSource={storeEmployee}
        >
          <DropDownOptions title="Выберите водителя" closeOnOutsideClick={true} showTitle={false} />
          {/*          <Validator>
            <RequiredRule message="Выберите водителя" />
          </Validator> */}
        </SelectBox>
      </AppFieldBox>

      <AppFieldBox label="Комментарий" labelTop>
        <TextArea
          stylingMode="underlined"
          placeholder="Введите комментарий"
          mode="text"
          value={form.comment || ''}
          onValueChange={(e: any) => {
            onChange('comment', e);
          }}
        />
      </AppFieldBox>
    </div>
  );
};
